import { createMobxStoreProvider } from "src/common/factories/createMobxStoreProvider.tsx";
import type { TabsStore } from "src/lib/tabs-ui/TabsStore.tsx";

export const { Provider: SimpleTabsProvider, useStore: useSimpleTabsStore } =
  createMobxStoreProvider<TabsStore>("SimpleTabs");
